import { Outlet } from "react-router-dom";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/dashboard/AdminSidebar";
import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { SEO } from "@/components/SEO";

export function AdminLayout() {
  return (
    <SidebarProvider>
      <SEO title="Admin" noindex={true} />
      <div className="dashboard-area min-h-screen flex w-full">
        <AdminSidebar />
        <SidebarInset>
          <DashboardHeader />
          <main className="flex-1 p-4 lg:p-6">
            <Outlet />
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
